<template>
  <div class="noticeBox" ref="noticeBoxRef">
    <!-- <XWViewHeader></XWViewHeader> -->
    <h2 class="applyExamTitle" ref="examTitleRef">{{ examInfo.examName }}</h2>
    <div class="applyMainBox" :style="{ height: mainBoxHeight }">
      <router-view />
    </div>
    <!--
      <XWViewFooter></XWViewFooter>
    -->
  </div>
</template>

<script>
import { getExamInfoList } from "@/api/apply";
import { getAreaData, getTypeDefData } from "@/api/common";

export default {
  name: "Apply",
  data() {
    return {
      dataList: [
        {
          // 民族
          typeClass: "AAC005",
          methods: "nationListChange",
        },
        {
          // 政治面貌
          typeClass: "AAC024",
          methods: "politicListChange",
        },
        {
          // 婚姻状况
          typeClass: "AAC017",
          methods: "marryListChange",
        },
        {
          // 最高学历
          typeClass: "AAA107",
          methods: "educationListChange",
        },
        {
          // 最高学位
          typeClass: "degree",
          methods: "degreeListChange",
        },
        {
          // 学历类别
          typeClass: "education_class",
          methods: "educationTypeChange",
        },
      ],
      // 考试基本信息
      examInfo: {},
      // 公告对话框
      dialogVisible: true,
      // 公告路径
      reportUrl: "/apply/contentInfo/getContentInfoByExamId?examId=",
      //
      jobName: "",
      // 显示一次报考结束提醒
      noticeCount: 0,
      mainBoxHeight: "auto",
    };
  },
  beforeMount() {
    window.groundParentMounted = this._isMounted;
  },
  mounted() {
    this.mainBoxHeight = this.$refs["noticeBoxRef"].offsetHeight - 102 + "px";

    // 存储examId
    if (this.$route.query.examId) {
      console.log("存入session");
      console.log("存入store");
      sessionStorage.setItem("examId", this.$route.query.examId);
      this.$store.commit("examIdChange", sessionStorage.getItem("examId"));
    }

    let _that = this;

    _that.reportUrl += _that.$store.state.examId;

    // 获取考试信息 examInfo
    getExamInfoList({ id: _that.$store.state.examId }, 1, 10).then((res) => {
      if (res.data.success) {
        console.log(res.data.obj.records[0]);
        _that.examInfo = res.data.obj.records[0];
        _that.$store.commit("examInfoChange", res.data.obj.records[0]);
        window.groundParentMounted = this._isMounted;
      }
    });

    // 获取公共数据
    _that.getCommonData();
  },
  methods: {
    // 查看报名信息
    checkApplyInfo() {},
    // 显示我的报考信息
    showPersonalExam() {
      if (this.$route.path == "/apply/personalExam") return;
      let _that = this;
      const loading = _that.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$router.push("/apply/personalExam");
      setTimeout(() => {
        loading.close();
      }, 500);
      return;
    },
    // 考试报考
    showApplyExam() {
      if (this.$route.path == "/apply/chooseJob") return;
      let _that = this;
      const loading = _that.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.$router.push("/apply/chooseJob");
      setTimeout(() => {
        loading.close();
      }, 500);
      return;
    },
    // 获取数据
    getCommonData() {
      let _that = this;
      this.dataList.forEach((item) => {
        getTypeDefData({ typeClass: item.typeClass }).then((res) => {
          if (res.data.success) {
            _that.$store.commit(item.methods, res.data.obj);
          }
        });
      });
      getAreaData().then((res) => {
        if (res.data.success) {
          let aeraList = res.data.obj;
          let data = [];
          aeraList.forEach((item) => {
            if (!item.disId) {
              data.push(item);
            }
          });
          _that.$store.commit("areaListChange", _that.aeraEach(data, aeraList));
        }
      });
    },
    // 生成树结构
    aeraEach(list, allData) {
      // console.log("生成树结构");
      let data = [];
      for (let i = 0; i < list.length; i++) {
        // 将当前级 插入
        data.push({
          // value: list[i].totalId,
          value: list[i].disName,
          label: list[i].disName,
        });
        let params = allData.filter(function (el) {
          return list[i].totalId == el.disId;
        });
        if (params.length > 0) {
          data[i].children = this.aeraEach(params, allData);
        }
      }
      return data;
    },
    // 关闭公告
    closeNotice() {
      let examEnd = new Date(this.examInfo.applyEnd).getTime();
      let nowTime = new Date().getTime();
      if (this.noticeCount > 0) {
        return;
      }
      if (nowTime > examEnd) {
        this.noticeCount++;
        this.$alert("本场考试报名已结束！", "报考结束", {
          confirmButtonText: "确定",
          callback: (action) => {
            // this.$message({
            //   type: "info",
            //   message: `action: ${action}`,
            // });
          },
        });
      }
    },
    // 前往登录
    toLogin() {
      this.$router.push("/login?examId=" + this.$store.state.examId);
    },
  },
};
</script>

<style>
.applyExamTitle {
  text-align: center;
  height: 100px;
  line-height: 100px;
  font-size: 44px;
  letter-spacing: 6px;
  border-bottom: 2px solid #eca91a;
  background-color: #1a6bc0;
  color: #fff;
}

.noticeBox {
  /*
  display: flex;
  flex-direction: column;
  */
  height: 100%;
}

.applyMainBox {
  flex: 1;
}

.noticeBox .el-dialog.is-fullscreen {
  display: flex;
  flex-direction: column;
}

.noticeBox .el-dialog__body {
  flex: 1;
}

.headBox {
  background-color: #f9f9f9;
}

.headLineBox {
  display: flex;
  height: 46px;
  padding: 8px 10px;
  align-items: center;
  user-select: none;
}

.headLine-c {
  flex: 1;
}

.checkApplyInfoBox {
  font-size: 14px;
  cursor: pointer;
  margin-right: 5px;
}

.checkApplyInfoBox:hover {
  color: red;
}

.breadBox {
  background-color: #ecf5ff;
  border: 1px solid #d9ecff;
  border-radius: 4px;
  margin-top: 10px;
  padding: 10px;
}

.headLine-r {
  height: 100%;
  display: flex;
  align-items: center;
}

.toLoginBtn {
  width: 80px;
  text-align: center;
  font-size: 14px;
  cursor: pointer;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.toLoginBtn:hover {
  border-radius: 2px;
  background-color: #f4f4f4;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}
</style>



// WEBPACK FOOTER //
// src/view/apply/Apply.vue